import { FC, useEffect } from 'react'

import { useDragNDrop } from '..'

const EnableDragAndDrop: FC<{ dragGroupIds: string[] }> = ({
  dragGroupIds,
}) => {
  const data = useDragNDrop(null, [], [])
  const { toggleDragDrops, enabledDragGroupIds } = data
  useEffect(() => {
    const disabledDragGroupIds = dragGroupIds.filter(
      (dragGroupId) => !enabledDragGroupIds.includes(dragGroupId),
    )
    if (disabledDragGroupIds.length) {
      toggleDragDrops(disabledDragGroupIds, 'enable')
    }
  }, [dragGroupIds, enabledDragGroupIds, toggleDragDrops])
  return null
}

export default EnableDragAndDrop
